import { createReducer, on } from '@ngrx/store';
import { ChangeCredentialsDialogState } from './change-credentials-dialog.state';
import { changeCredentialsDialogStateInitial } from './change-credentials-dialog.state.initial';
import { ChangeCredentialsDialogActions } from './change-credentials-dialog.actions';

/**
 * Reducer für den Change-Credentials-Dialog.
 */
export const changeCredentialsDialogReducers = createReducer(
  changeCredentialsDialogStateInitial,

  on(
    ChangeCredentialsDialogActions.open,
    (state, { title, prompt, url }): ChangeCredentialsDialogState => ({
      ...state,
      isOpen: true,
      title,
      prompt,
      url,
    }),
  ),

  on(
    ChangeCredentialsDialogActions.close,
    (state): ChangeCredentialsDialogState => ({
      ...state,
      isOpen: false,
      title: undefined,
      prompt: undefined,
      url: undefined,
    }),
  ),

);
